/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Score_Anatomy_DescInputs */

const en_directory_detail_score_anatomy_desc = /** @type {(inputs: Directory_Detail_Score_Anatomy_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The dimensions behind the editorial score, each with its judgment note.`)
};

const zh_directory_detail_score_anatomy_desc = /** @type {(inputs: Directory_Detail_Score_Anatomy_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑评分由哪些维度构成，每项附判断依据。`)
};

/**
* | output |
* | --- |
* | "The dimensions behind the editorial score, each with its judgment note." |
*
* @param {Directory_Detail_Score_Anatomy_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_score_anatomy_desc = /** @type {((inputs?: Directory_Detail_Score_Anatomy_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Score_Anatomy_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_score_anatomy_desc(inputs)
	return zh_directory_detail_score_anatomy_desc(inputs)
});
export { directory_detail_score_anatomy_desc as "directory.detail.score_anatomy_desc" }